import { useDroppable } from "@dnd-kit/core";
import { STAGE_STYLES } from "@/lib/constants";
import { PipelineCard } from "@/components/crm/pipeline/PipelineCard";
import { slugify } from "@/lib/constants";

export const PipelineColumn = ({ column, onMove, onLoadMore }) => {
  const { setNodeRef, isOver } = useDroppable({ id: column.stage });
  const slug = slugify(column.stage);
  return (
    <div ref={setNodeRef} data-testid={`pipeline-column-${slug}`}
         className={`flex w-[280px] shrink-0 flex-col rounded-2xl border p-3 transition-colors sm:w-[300px] ${isOver ? "border-[#1E6FD9]/40 bg-[#1E6FD9]/[0.05]" : "border-slate-200/70 bg-white/60"}`}>
      <div className="mb-3 flex items-center justify-between px-1">
        <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${STAGE_STYLES[column.stage]}`}>{column.stage}</span>
        <span className="text-xs font-semibold text-slate-400" data-testid={`pipeline-count-${slug}`}>{column.count}</span>
      </div>
      <div className="flex min-h-[120px] flex-1 flex-col gap-2.5">
        {column.leads.map((l) => <PipelineCard key={l.id} lead={l} onMove={onMove} />)}
        {column.leads.length < column.count && (
          <button onClick={() => onLoadMore(column.stage)} data-testid={`pipeline-load-more-${slug}`}
                  className="rounded-xl border border-slate-200 bg-white py-2 text-xs font-semibold text-[#1E6FD9] transition-colors hover:bg-[#1E6FD9]/[0.05]">
            Cargar más ({column.count - column.leads.length})
          </button>
        )}
        {column.leads.length === 0 && <p className="rounded-xl border border-dashed border-slate-200 py-6 text-center text-xs text-slate-400">Sin leads</p>}
      </div>
    </div>
  );
};
